module.exports = __webpack_public_path__ + "static/media/score-balls.7340f359.png";